const opinion = {
    add: 'opinion/add',
    getlist: 'opinion/getlist',
    update: 'opinion/update',
    remove: 'opinion/remove',
    get: 'opinion/get',
}
export default opinion